import axios from 'axios';

export const ChangePasswordService = {
  async changePassword(payload) {
    const res = await axios.put('rbac/v1/change_password/', payload);

    if (res.status === 200) {
      return res;
    }

    return Promise.reject();
  },
};
